import { ReactComponent as Moped } from '../assets/moped.svg';
import { roadCss } from './road.styles';

export type ApplyMiniRoadProps = {
  /** Drifts in on first paint. Replaying it on every re-render reads as a glitch. */
  isPlaying?: boolean;
  /** Rides out — the hand-off to the journey's progress bar when Start is pressed. */
  isLeaving?: boolean;
};

/**
 * The intro road: the same track, trail and scooter as the progress bar, sized into the
 * role box with the scooter flush right and the trail ending on its centre.
 *
 * It does not clip itself — the role box does — so the scooter reads as riding in and
 * out of a window rather than fading on the spot.
 */
export const ApplyMiniRoad = ({ isPlaying = false, isLeaving = false }: ApplyMiniRoadProps) => (
  <div css={roadCss.mini} aria-hidden="true">
    <div css={[roadCss.track, roadCss.miniTrack, isPlaying && !isLeaving && roadCss.miniPlay]}>
      <div css={[roadCss.fill, roadCss.miniFill, isLeaving && roadCss.leavingFill]} />
      <span css={[roadCss.rider, roadCss.riderLarge, roadCss.miniRider, isLeaving && roadCss.leavingRider]}>
        <span css={[roadCss.vehicle, roadCss.vehicleLarge]}>
          <Moped />
        </span>
      </span>
    </div>
  </div>
);
